
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.494663 0.492258C-0.161628 1.1486 -0.161628 2.21275 0.494663 2.86909L7.62378 9.99878L0.492218 17.1309C-0.164073 17.7873 -0.164073 18.8514 0.492218 19.5077C1.14851 20.1641 2.21257 20.1641 2.86886 19.5077L10.0004 12.3756L17.1311 19.5069C17.7874 20.1633 18.8515 20.1633 19.5078 19.5069C20.1641 18.8506 20.1641 17.7864 19.5078 17.1301L12.3771 9.99878L19.5053 2.86992C20.1616 2.21357 20.1616 1.14943 19.5053 0.493086C18.849 -0.163258 17.785 -0.163258 17.1287 0.493086L10.0004 7.62195L2.8713 0.492258C2.21501 -0.164086 1.15095 -0.164086 0.494663 0.492258Z"}})])
          )
        }
      }
    